import { AmberHoc, AmberHocProps } from '../../../util';
import {
  CreateGrainBinTicketMutationVariables as Variables,
  GrainBinTicketRowFragmentFragment as Result,
  withCreateGrainBinTicket as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithCreateGrainBinTicketHocChildProps = {
  createGrainBinTicket: (variables: Variables) => Promise<Result>;
};

export const withCreateGrainBinTicketHoc: AmberHoc<{}, WithCreateGrainBinTicketHocChildProps> = (
  component
) =>
  HOC<
    AmberHocProps<{}, WithCreateGrainBinTicketHocChildProps, typeof component>,
    WithCreateGrainBinTicketHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        createGrainBinTicket: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { data, errors } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data || !data.createGrainBinTicket) {
            throw new Error('Unexpected server response');
          }
          return data.createGrainBinTicket;
        },
      };
    },
  })(component as any);
